(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ConversationCustomDialogController', ConversationCustomDialogController);

    ConversationCustomDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Conversation', 'Company', 'ServiceItem', 'PersonInfo', 'Message', 'MessageCustom', 'ConversationCustom'];

    function ConversationCustomDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Conversation, Company, ServiceItem, PersonInfo, Message, MessageCustom, ConversationCustom) {
        var vm = this;

        vm.conversation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.companies = Company.query();
        vm.serviceitems = ServiceItem.query();
        vm.personinfos = PersonInfo.query();
        vm.messages = Message.query();


        vm.findMessageStyle = findMessageStyle;
        vm.senderName = senderName;


        updateMessagesStatus();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            //if (vm.conversation.id !== null) {
            //    Conversation.update(vm.conversation, onSaveSuccess, onSaveError);
            //} else {
            //    Conversation.save(vm.conversation, onSaveSuccess, onSaveError);
            //}

            newMessageFromSupplier();
        }

        function onSaveSuccess(result) {
            $scope.$emit('tikonApp:conversationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function findMessageStyle(senderType) {
            return "message-" + senderType;
        }

        function senderName(message) {
            var result;
            if (message.senderType == "SUPPLIER") {
                result = vm.conversation.toPerson;
            }
            if (message.senderType == "CUSTOMER") {
                result = vm.conversation.fromPerson;
            }


            return result.fisrtName + ' ' + result.lastName;
        }

        function newMessageFromSupplier() {
            if (vm.newMessage == null || vm.newMessage == undefined) {
                return;
            }
            if (vm.conversation.id == null || vm.conversation.id == undefined) {
                return;
            }

            var messageDto = {};
            messageDto.id = null;
            messageDto.senderType = null;
            messageDto.createDate = null;
            messageDto.status = null;
            messageDto.conversationId = vm.conversation.id;
            messageDto.content = vm.newMessage;

            MessageCustom.newMessageFromSupplier().save(messageDto, onSaveSuccess, onSaveError);

        }

        function updateMessagesStatus() {
            if (vm.conversation != null && vm.conversation != undefined)
                ConversationCustom.setConversationMessageSeenBySupplier().save(vm.conversation.id, onUpdateSuccess, onUpdateError);
        }

        function onUpdateSuccess() {
        }

        function onUpdateError() {
        }


    }
})();
